import CONTRATO_ACTIVIDADES_TODAS from '@/graphql/querys/administracion/contratos/contrato/reporteactividades/contratoActividadesTodas.gql';
import MARCAR_COMO_PROBLEMA_RESUELTO from '@/graphql/mutations/administracion/contratos/contrato/reporteactividades/marcarComoProblemaResuelto.gql';

export default {
  apollo: {
    contratoActividadesTodas: {
      query: CONTRATO_ACTIVIDADES_TODAS,
    },
  },
  methods: {
    async mixMarcarComoProblemaResuelto() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: MARCAR_COMO_PROBLEMA_RESUELTO,
        variables: {
          id: this.contratoActividad.id,
        },
        update: (store) => {
          const data = store.readQuery({
            query: CONTRATO_ACTIVIDADES_TODAS,
          });
          const { contratoActividadesTodas } = data;
          const index = contratoActividadesTodas
            .findIndex((actividad) => actividad.id === this.contratoActividad.id);
          if (index !== -1) {
            contratoActividadesTodas.splice(index, 1);
          }
          store.writeQuery({ query: CONTRATO_ACTIVIDADES_TODAS, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

  },
  computed: {
    mixGetContratoActividadesTodas() {
      if (!this.contratoActividadesTodas) return [];
      return this.contratoActividadesTodas
        .filter((actividad) => actividad.esProblema && !actividad.problemaResuelto);
    },
  },
};
